export default "__VITE_ASSET__vs2RhQtY__"